import logo2009 from "../../assets/img/historicEvents/LogoHellInACell/2009.png";
import logo2010_2013 from "../../assets/img/historicEvents/LogoHellInACell/2010-2013.png";
import logo2014_2016 from "../../assets/img/historicEvents/LogoHellInACell/2014-2016.png";
import logo2017 from "../../assets/img/historicEvents/LogoHellInACell/2017.png";
import logo2018_2019_2021_2022 from "../../assets/img/historicEvents/LogoHellInACell/2018-2019-2021-2022.png";
import logo2020 from "../../assets/img/historicEvents/LogoHellInACell/2020.png";

export const hellInACellDetail = {
  "hell-in-a-cell": {
    id: "hell-in-a-cell",
    title: "Hell in a Cell",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "hell-in-a-cell",
        items: [
          {
            id: "hell-in-a-cell-2009",
            title: "Hell In A Cell",
            description: "2009",
            imgUrl: logo2009,
          },
          {
            id: "hell-in-a-cell-2010",
            title: "Hell In A Cell",
            description: "2010 - 2013",
            imgUrl: logo2010_2013,
          },
          {
            id: "hell-in-a-cell-2014",
            title: "Hell In A Cell",
            description: "2014 - 2016",
            imgUrl: logo2014_2016,
          },
          {
            id: "hell-in-a-cell-2017",
            title: "Hell In A Cell",
            description: "2017",
            imgUrl: logo2017,
          },
          {
            id: "hell-in-a-cell-2018",
            title: "Hell In A Cell",
            description: "2018 - 2019",
            imgUrl: logo2018_2019_2021_2022,
          },
          {
            id: "hell-in-a-cell-2020",
            title: "Hell In A Cell",
            description: "2020",
            imgUrl: logo2020,
          },
          {
            id: "hell-in-a-cell-2018",
            title: "Hell In A Cell",
            description: "2021 - 2022",
            imgUrl: logo2018_2019_2021_2022,
          },
        ],
      },
    ],
  },
};
